import { getEwpApiUrl } from '../selectors/selectors';

export default {
  fetch: ({ data }, action, state) => {
    const formData = new FormData();
    /* append form data with "request" and "files" key, each key containing values like
    request : LRG form data object
    files: list of files and their data to upload
    respectively */
    formData.append('request', JSON.stringify(data.lowestRateFormDetailsData));
    data.fileList.forEach((file) => formData.append('files', file));
    return {
      url: `${getEwpApiUrl(state)}/travel/v1/email/lowest_rate_guaranteed_claim`,
      opts: {
        method: 'POST',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
        },
        body: formData,
      },
    };
  },
};
